import { Routes, Route } from 'react-router-dom';
import UwinMainPage from '../modules/uwin/pages/UwinMainPage';
import { Linkedchildren } from '../modules/uwin/components/Linkedchildren';
import { Pregnancyhistory } from '../modules/uwin/components/Pregnancyhistory';
import { Vaccinationuwin } from '../modules/uwin/components/Vaccinationuwin';

const UWINRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UwinMainPage />} />
      <Route path="/main" element={<UwinMainPage />} />
      <Route path="/linked-children" element={<Linkedchildren />} />
      <Route path="/pregnancy-history" element={<Pregnancyhistory />} />
      <Route path="/vaccination" element={<Vaccinationuwin />} />
    </Routes>
  );
};

export default UWINRoutes;